import * as tslib_1 from "tslib";
export function fetchAllInBatches(service, params, takeUntil) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var limit, items, offset, total, takeMore, result;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    limit = 200;
                    items = [];
                    offset = 0;
                    total = 0;
                    takeMore = true;
                    _a.label = 1;
                case 1: return [4 /*yield*/, service.search(tslib_1.__assign({}, params, { limit: limit,
                        offset: offset }))];
                case 2:
                    result = _a.sent();
                    items = items.concat(result.items);
                    total = result.items.length;
                    offset += limit;
                    takeMore = takeUntil ? items.length < takeUntil : true;
                    _a.label = 3;
                case 3:
                    if (total >= limit && takeMore) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4: return [2 /*return*/, items];
            }
        });
    });
}
